import * as React from "react";
const SvgFiRrRacquet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-racquet_svg__a)">
      <path
        fill="#062147"
        d="M21.923 2.067C18.758-1.1 13.077-.57 9.258 3.247A10.6 10.6 0 0 0 6.02 10.9q.039.72.157 1.433c.149 1.57.129 3.938-.884 4.95l-5 5A1 1 0 1 0 1.707 23.7l5-5c1.025-1.023 3.433-1.033 5-.88q.805.131 1.62.164a10.67 10.67 0 0 0 7.412-3.25c3.82-3.82 4.35-9.5 1.184-12.667m-.517 8.154-1.482-1.482 2.043-2.04a7.45 7.45 0 0 1-.561 3.522m-.1-5.69L18.51 7.326 16.584 5.4l2.753-2.753c.43.218.825.5 1.172.835.31.312.576.665.79 1.05zm-8.27 11.449-.3-.051 2.242-2.241 1.568 1.568a7.7 7.7 0 0 1-3.51.724M8.01 10.95a7.7 7.7 0 0 1 .724-3.5l1.487 1.487-2.182 2.18q-.015-.091-.03-.166m2.532 4.343a4.7 4.7 0 0 1-1.9-1.952l2.992-2.993 1.926 1.926zm2.507-6.36 2.12-2.12 1.93 1.926-2.124 2.12zm4.079-6.906L15.17 3.985l-1.4-1.4a7.7 7.7 0 0 1 2.89-.6c.163.003.313.03.468.042m-5.18 1.565L13.757 5.4l-2.121 2.12-1.842-1.841a9.4 9.4 0 0 1 2.156-2.087m-3.9 12.346c0-.014.006-.03.009-.043l.017.019.018.017zm10.26-1.74-1.922-1.924 2.12-2.121 1.894 1.89q-.483.684-1.073 1.276-.479.475-1.015.88z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-racquet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRacquet;
